import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=4ecf611c"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=4ecf611c&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecf611c')) {
      api.createRecord('4ecf611c', component.options)
    } else {
      api.reload('4ecf611c', component.options)
    }
    module.hot.accept("./BasicLayout.vue?vue&type=template&id=4ecf611c", function () {
      api.rerender('4ecf611c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/BasicLayout.vue"
export default component.exports